import { mapToSelectOptions } from '../../../infrastructure/helpers/html/selectOptionHelper';
import { reportTypeDisplayMap } from '../../../infrastructure/constants/reportType';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import ReportConfig from '../../../types/report/ReportConfig';
import SelectOption from '../../../infrastructure/types/SelectOption';
import reportSubRegime from '../../../infrastructure/constants/reportSubRegime';
import ReportCollections from '../../../infrastructure/types/Functions/ReportCollections';
import Mode from '../../../types/report/Mode';
import ReportVariable from '../../../types/report/ReportVariable';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import Operand from '../../../types/functions/Operand/Operand';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';

const getConfigOptionValue = (config: IngestionConfigOption): string => (config.id as number).toString();
const getConfigOptionText = (config: IngestionConfigOption): string => {

    if (config.dataSourceKind === dataSourceKind.accuracy ||
        config.dataSourceKind === dataSourceKind.globalRef) {

        return config.name;
    }

    return `${config.name} (${config.dataSourceKind})`
};

const isDataSourceReferencedInCurrentConfig = (dataSourceId: number, reportConfig: ReportConfig, dataSources?: IngestionConfig[]|null): boolean => {
    return (
        reportConfig.isinSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.leiSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.exchangeRatesSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.annaDsbUpiEnrichmentSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.lseSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.symbolSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.firdsFcaInstrumentSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.firdsEsmaInstrumentSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.annaDsbUpiSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.fcaRegulatedEntitiesSelectors?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.lookups?.some(x => x.dataSource1Id === dataSourceId || x.dataSource2Id === dataSourceId) ||
        reportConfig.variables?.some(x => x.dataSourceId === dataSourceId) ||
        getVariableDataSourceUsed(reportConfig.variables, dataSources).some(x => x === dataSourceId) ||
        reportConfig.filters?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.cases?.some(x => x.dataSourceId === dataSourceId) ||
        reportConfig.dictionaries?.some(x => x.dataSourceId === dataSourceId)
    );
}

const getVariableDataSourceUsed = (variables: ReportVariable[], dataSources?: IngestionConfig[] | null): number[] => {

    if (!dataSources || dataSources.length === 0) {
        return [];
    }

    let fieldsMap = new Map<number, number>();

    dataSources.forEach((ds) => {
        ds.fieldDefinitions.forEach((field) => {
            fieldsMap.set(field.id as number, ds.id as number);
        });
    });

    let uniqueDataSourceIds = new Set<number>();

    variables.forEach((v) => {

        operandHelper.proceedWhitAssignment(v.assignment, (operand: Operand) => {
            if (operand.fieldId && operand.fieldId > 0) {

                let id = fieldsMap.get(operand.fieldId as number) as number;
                uniqueDataSourceIds.add(id);
            }
        });
    });

    return Array.from(uniqueDataSourceIds);
}

const runAllOptions: SelectOption[] = [
    { text: 'Latest Only', value: "0" },
    { text: 'Run All', value: "1" },
    { text: 'Oldest Only', value: "2" }
];

const reportTypeOptions: SelectOption[] = Object.keys(reportTypeDisplayMap).map(key => { return { value: key, text: reportTypeDisplayMap[key] } });

const getSubRegimeOptions = (regime: string) => mapToSelectOptions(reportSubRegime(regime));

const regimeOptions = (regimes: { [key: string]: any }) => mapToSelectOptions(regimes);

export {
    getConfigOptionValue,
    getConfigOptionText,
    runAllOptions,
    reportTypeOptions,
    regimeOptions,
    getSubRegimeOptions,
    isDataSourceReferencedInCurrentConfig
};
